/* Site-wide lazy-load watchdog (2026-07-30).
   Native loading="lazy" images have been confirmed, by direct testing, to
   sometimes get permanently stuck at 0x0 — img.complete stays false and no
   network request ever fires — even once the element is scrolled fully
   into view. First found on image-with-text-custom sections; now also
   confirmed on the main product gallery (product-media-gallery.liquid),
   where every non-featured image on a product page can get stuck this way.
   Forcing loading='eager' + re-touching src/srcset always fixes it
   immediately, proving the image URL is fine and only the browser's own
   lazy-load trigger is failing to fire.

   This runs site-wide (not scoped to one component) via a timer-based
   watchdog rather than IntersectionObserver, since IntersectionObserver
   callbacks were separately confirmed to sometimes fail to fire at all in
   certain rendering contexts too — relying on IntersectionObserver to fix
   an IntersectionObserver-adjacent bug is fragile. setInterval doesn't
   depend on any render-tied observer callback at all, so it fires
   reliably in every context. Stops once every tracked image has loaded
   (or after a generous cutoff) so it never runs forever. */
(function () {
  if (window.__lazyLoadWatchdogInit) return;
  window.__lazyLoadWatchdogInit = true;

  var VIEWPORT_MARGIN = 800; // px — unstick a bit before it's actually visible
  var POLL_INTERVAL = 300;   // ms
  var MAX_POLLS = 150;       // ~45s ceiling, generous but not infinite
  var unstuckImages = new WeakSet();

  function forceLoad(img) {
    if (unstuckImages.has(img)) return;
    unstuckImages.add(img);
    img.loading = 'eager';
    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');
    if (src) img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
  }

  /* HIDDEN-IMAGE FIX (2026-10-14): images inside display:none containers
     (for example the desktop mega menu while it is closed) report a
     0x0 rect at the top of the page, which looked "near the viewport" and
     made the watchdog download all of them on every page load
     (about 477 KiB). Images that are not rendered are now skipped; they
     load as soon as their container becomes visible. */
  function isRendered(img) {
    if (typeof img.checkVisibility === 'function') {
      return img.checkVisibility();
    }
    return img.offsetParent !== null || (img.getClientRects && img.getClientRects().length > 0);
  }

  function pollLazyImages() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    var stillPending = false;
    var toForceLoad = [];

    /* FORCED-REFLOW FIX (2026-08-03): reads (getBoundingClientRect) and
       writes (forceLoad, which mutates src/srcset) used to be interleaved
       in a single pass over every lazy image on the page — writing one
       image invalidates the layout the browser just computed, forcing a
       fresh synchronous layout recalculation on the very next image's
       rect read ("layout thrashing"). This pass now only READS; nothing
       is written to the DOM yet, so the browser can do one layout pass
       for the whole batch instead of one per image. */
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      stillPending = true;

      if (!isRendered(img)) return;

      var rect = img.getBoundingClientRect();
      var nearViewport =
        rect.bottom > -VIEWPORT_MARGIN &&
        rect.top < window.innerHeight + VIEWPORT_MARGIN;

      if (nearViewport) toForceLoad.push(img);
    });

    // Second pass: all the writes, now that every read above is done.
    toForceLoad.forEach(forceLoad);

    return stillPending;
  }

  var pollCount = 0;
  var pollTimer = setInterval(function () {
    pollCount++;
    var stillPending = pollLazyImages();
    if (!stillPending || pollCount >= MAX_POLLS) {
      clearInterval(pollTimer);
    }
  }, POLL_INTERVAL);

  // Check immediately on load/DOMContentLoaded rather than waiting for the
  // first interval tick, and also on Shopify's own section-load event so
  // dynamically-inserted content (theme editor edits, AJAX product-info
  // swaps, quick-add modals) gets covered without a full page reload.
  document.addEventListener('DOMContentLoaded', pollLazyImages);
  window.addEventListener('load', pollLazyImages);
  document.addEventListener('shopify:section:load', pollLazyImages);
})();
